import { type FC } from 'react';
import { Spinner } from '@george-labs.com/design-system';

import { BankMessageDetailsError } from './BankMessageDetailsError';
import { BankMessageDetailsNotFoundError } from './BankMessageDetailsNotFoundError';
import type { BankMessage } from '../BankMessagesTypes';
import { BankMessageView } from './BankMessageView';
import { useAutoMarkBankMessageRead } from './useAutoMarkBankMessageRead';
import {
    trackBankMessageAttachmentSelected,
    trackOpenBankMessageDetail,
} from '../BankMessagesTrackingService';

interface Props {
    showIcon?: boolean;
    isLoading: boolean;
    error: any;
    message: BankMessage | undefined;
    overviewAbsolutePath: string;
    refetch: () => void;
}

const NOT_FOUND_ERROR_STATUS = 404;

export const BankMessageDetails: FC<Props> = ({
    showIcon,
    error,
    isLoading,
    message,
    overviewAbsolutePath,
    refetch,
}) => {
    useAutoMarkBankMessageRead(message);

    if (!message && isLoading) {
        return <Spinner center size={Spinner.SIZE.MEDIUM} />;
    }

    if (error?.status === NOT_FOUND_ERROR_STATUS) {
        return <BankMessageDetailsNotFoundError overviewAbsolutePath={overviewAbsolutePath} />;
    }

    if (!!error || !message) {
        return <BankMessageDetailsError refetch={refetch} />;
    }

    return (
        <BankMessageView
            showIcon={showIcon}
            message={message}
            onBankMessageDisplayed={trackOpenBankMessageDetail}
            onAttachmentDownload={trackBankMessageAttachmentSelected}
        />
    );
};
